<div class="bg--image" [ngClass]="imageClass" [ngStyle]="backgroundStyle">
    <img *ngIf="!imageLoaded" [src]="image" (load)="onImageLoad()" class="image--loader">
    <span class="featured" *ngIf="featured">Featured</span>
    <span class="recommended" *ngIf="recommended">Recommended</span>
</div>
